export default __webpack_public_path__ + "static/media/zoomIN.c8a8ff70.svg";